module.exports = __webpack_public_path__ + "img/Boleto.21accac.png";